import script from "./sso-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./sso-settings.vue?vue&type=script&setup=true&lang=js"

import "./../../resources/css/sso-settings.scss?vue&type=style&index=0&id=6623624c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6623624c"]])

export default __exports__